import "../css/default.css";

import hotel from "../Asset/hotel.png";
import sea from "../Asset/resort/sea9.webp";
import sunset from "../Asset/sunset.png";
import threestar from "../Asset/3-stars.png";
import parkingaera from "../Asset/parking-area.png";
import barcounter from "../Asset/bar-counter.png";
import pool from "../Asset/swimming-pool.png";
import I1 from "../Asset/HOMEICON/l1.png";
import I2 from "../Asset/HOMEICON/I2.png";
import I3 from "../Asset/HOMEICON/I3.png";
import I4 from "../Asset/HOMEICON/I4.png";
import I5 from "../Asset/HOMEICON/I5.png";
import abbout1 from "../Asset/abbout1.jpg";
import backgroundfood from "../Asset/food/background.jpg"
import I6 from "../Asset/HOMEICON/I6.png";
import Fade from "react-reveal";
import { BiFoodTag } from "react-icons/bi";
import sea3 from "../Asset/resort/sea.webp";
import siamain from "../Asset/siamain.jpg";
import games from "../Asset/games.png"
import sea5 from "../Asset/resort/sea5.webp";
import sea6 from "../Asset/resort/sea6.webp";

import abback from "../Asset/homeback.jpg";
import home3 from "../Asset/abbout.jpg";
import aboutbanner1 from "../Asset/aboutbaner1.jpg";
// import sea from "../Asset/resort/sea9.webp"
import rroms from "../Asset/coze/Cozy Villa (1bhk)_page-0008.jpg";
import coze from "../Asset/grand/img52.jpg";
import seaa from "../Asset/resort/sea3.webp";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Slider from "../components/Slider";
import { Zoom } from "react-reveal";
import backgroundcover from "../Asset/backgroundset1.jpg";
import { Bounce } from "react-reveal";
import ture from "../Asset/turegide.png"
import bornfire from "../Asset/bornfiree.png"
import "../css/Food.css"
import krokio from "../Asset/kriko.png"

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules

import Hadder from "../components/Hadder";
import buttergarlic from "../Asset/food/Butter garlic crab.jpeg"
import crabsmasala from "../Asset/food/Crab masala.jpeg"
import clabsplatter from "../Asset/food/Crab platter.jpg"
import pomfretgrilled from "../Asset/food/Pomfret grilled.jpg"
import porfedtandoor from "../Asset/food/Pomfret tandoori.jpg"
import greensalad from "../Asset/food/greensalad.jpg"
import tandoorrawas from "../Asset/food/Tandoori rawas.jpeg"
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import React, { useRef, useLayoutEffect, useState } from 'react'
import vegplatter from "../Asset/food/Veg platter.jpg"
import $ from "jquery";
import "../css/responsive.css"
const Home = (props) => {
  const [show, setShow] = useState(false);
  const formRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalShow, setModalShow] = React.useState(false);

  // email
  const [custName, setCustName] = useState("");
  const [custEmail, setCustEmail] = useState("");

  const [custContact, setCustContact] = useState("");
  const [custSubject, setCustSubject] = useState("");
  const [custMessage, setCustMessage] = useState("");
  //////////


  const Appoinment = (e) => {
    var body =
      '<!DOCTYPE html><html> <head> <title>Sia Resort</title> <meta http-equiv="Content-Type" content="text/html; charset=utf-8"> <meta name="viewport" content="width=device-width,initial-scale=1"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> </head> <body style="margin:0!important;padding:0!important;background-color:#eee" bgcolor="#eeeeee"> <div style="display:none;font-size:1px;color:#fefefe;line-height:1px;font-family:Open Sans,Helvetica,Arial,sans-serif;max-height:0;max-width:0;opacity:0;overflow:hidden"></div><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#fff"> <tr> <td align="center" style="background-color:#eee" bgcolor="#eeeeee"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"> <tr> <td align="center" valign="top" style="font-size:0;padding:10px" bgcolor="#FFD44C"> <div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:6px;font-weight:800;line-height:10px" class="mobile-center"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"> <tr> <td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;line-height:24px;padding:10px"> <a href="tel:+91 986745454" style="text-decoration:none;color:#000;font-family:serif;font-size:16px">Leade Generate for Sia Resort</a> </td></tr></table> </td></tr></table> </div></td></tr><tr> <td align="center" valign="top" style="font-size:0;padding:15px" bgcolor="#fff"> <div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"> <tr> <td align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:36px;font-weight:800;line-height:48px" class="mobile-center"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px"> <tr> <td width="100%" align="center" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-weight:800"> <img style="width:100%;height:120px" src="" alt=""> </td></tr></table> </td></tr></table> </div></td></tr><tr> <td align="center" valign="top" style="font-size:0;padding:0" bgcolor="#FFD44C"> <div style="display:inline-block;max-width:100%;min-width:100px;vertical-align:top;display:fle;justify-content:center;align-items:center;width:100%"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%"> <tr> <td width="100%" align="center" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:800;padding:10px 0" class="mobile-center"> <h1 style="text-transform:capitalize;font-size:14px;font-weight:500;margin:0;text-align:center;color:#000">Client Enquiry Details</h1> </td></tr></table> </div></td></tr><tr> <td align="center" height="100%" valign="top" width="100%" style="padding:0 35px 35px 35px;background-color:#fff" bgcolor="#eee"> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:660px"> <tr> <td width="100%" align="center" valign="top" style="font-size:0"> <div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;text-align:center;width:100%"> <table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:300px"> <tr> <td width="100%" align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Name:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custName +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Email:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custEmail +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer contact:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custContact +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Message:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custMessage +
      '</p></td></tr></table> </div><div style="display:inline-block;max-width:50%;min-width:240px;vertical-align:top;width:100%"> <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px"> <tr> <td align="left" valign="top" style="font-family:Open Sans,Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;line-height:24px"> <p style="font-size:16px;font-weight:600;color:#0074be">Customer Subject:</p><p style="font-size:14px;font-weight:500;color:#111">' +
      custSubject +

      '</p></td></tr></table> </div></td></tr></table> </td></tr><tr> <td width="100%" align="center" bgcolor="#FFD44C" style="padding:10px 0"> <p style="color:#000;font-weight:500;font-size:1rem;padding:0;margin:0">Sia Resort</p></td></tr></table> </td></tr></table> </body></html> ';
    // console.log(custServices)
    $.post(
      "https://skdm.in/server/v1/send_lead_mail.php",
      {
        toEmail: "sales@siaresort.com",
        fromEmail: "skdmlead@gmail.com",
        bccMail: "skdmlead@gmail.com",
        mailSubject: "New Customer Lead",
        mailBody: body,
        accountName: "searesort",
        accountLeadSource: "https://canvasvilla.co.in/",
        accountLeadName: custName,
        // accountLeadEmail: custEmail,
      },
      function (dataa, status) {
        console.log("data :" + dataa);
        // console.log("name:" + custName);
        // console.log("name:" + custEmail);
        // console.log("name:" + custCheckIn);
      }
    );

    alert("Your Form has Submitted Our team will contact with You  soon.");
    e.preventDefault();
    return false;
  };
  return (
    <div>
      <Slider />
      <section className="about-area about-p pt-120 pb-120 p-relative fix">
        <div className="animations-02">
          <img
            src="https://htmldemo.zcubethemes.com/riorelax/img/bg/an-img-02.png"
            alt="contact-bg-an-02"
          />
        </div>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <Fade left>
                <div
                  className="s-about-img p-relative  wow fadeInLeft  animated"
                  data-animation="fadeInLeft"
                  data-delay=".4s"
                  style={{ visibility: "visible", animationName: "fadeInLeft" }}
                >
                  <img
                    src={abbout1}
                    alt="img"
                    style={{ width: "100%" }}
                  />
                  {/* <div className="about-icon">
            <img src="https://www.siaresort.com/img/gallery/gallery-8.jpg" alt="img" style={{width:"370px",height:"413px"}} />
          </div> */}
                </div>
              </Fade>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <Fade right>
                <div
                  className="about-content s-about-content  wow fadeInRight   pl-30 animated"
                  data-animation="fadeInRight"
                  data-delay=".4s"
                  style={{
                    visibility: "visible",
                    animationName: "fadeInRight",
                  }}
                >
                  <div className="about-title second-title pb-25">
                    <h5>About Us</h5>
                    <h2>Most Safe &amp; Rated Resort In Alibag.</h2>
                  </div>
                  <p>
                    Welcome to Sia Resort, the epitome of luxury and relaxation, crowned the Best Resort in Alibaug. Nestled in the heart of serene landscapes, we redefine hospitality with a blend of elegance and comfort. Our commitment lies in providing an
                  </p>
                  <p>
                    Experience an unforgettable getaway, where every detail is meticulously crafted to surpass your expectations. Whether you crave rejuvenation or adventure, our resort offers an array of amenities and activities tailored to your desires. From exquisite dining to thrilling excursions, immerse yourself in unparalleled luxury. Discover Sia Resort, where every moment is a testament to excellence and the art of hospitality.
                  </p>
                  <div className="about-content3 mt-30">
                    <div className="row justify-content-center align-items-center">
                      <div className="col-md-12">
                        <ul className="green mb-30">
                          <li>
                            {" "}
                            Sun-kissed shores, historic forts, and vibrant local culture beckon.
                          </li>
                          <li>
                            {" "}
                            Serene coastal retreat offering relaxation, adventure, and cultural immersion.
                          </li>
                          <li>
                            {" "}
                            Scenic beauty, seafood delights, and unforgettable memories await visitors.
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <div className="slider-btn">
                          <a
                            href="/aboutus"
                            className="btn ss-btn smoth-scroll"
                          >
                            Discover More
                          </a>
                        </div>
                      </div>
                      <div className="col-md-6 text-right">
                        <div className="signature">
                          {/* <img src="img/features/signature.png" alt="img" /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>
      <section
        id="service-details2"
        className="pt-120 pb-90 p-relative"
        style={{
          backgroundColor: "#f7f5f1",
          // backgroundImage: `url(${abback})`,
          background: `linear-gradient(to right, rgb(0,0,0,.5), rgb(0,0,0,.5)),url(${abback})`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundSize: "100% 100%",
        }}
      >
        <div className="animations-01"></div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="section-title center-align mb-50 text-center">
                <h5 >Explore</h5>
                <h2 style={{ color: "white" }}>The Resort</h2>
                <p style={{ color: "white" }}>
                  Our amenity offers serene landscapes, modern facilities, and a vibrant community, fostering a truly enriching living experience for all.
                </p>
              </div>
            </div>
            <Swiper
              slidesPerView={1}
              spaceBetween={10}
              // pagination={{
              //   clickable: true,
              // }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
              loop={true}
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper"
            >

              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={hotel} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={hotel} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#"> Quality Room</a>
                      </h3>
                      <p>
                        Exquisite ambiance, plush amenities, tranquil setting; perfect for relaxation and rejuvenation.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={threestar} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={threestar} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Best Accommodation</a>
                      </h3>
                      <p>
                        Exquisite lodging for tranquil relaxation and rejuvenating comfort awaits you.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={parkingaera} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={parkingaera} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Parking </a>
                      </h3>
                      <p>
                        Reserved parking space available for tenants and visitors. Inquire within.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={barcounter} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={barcounter} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Restaurants &amp; Bars</a>
                      </h3>
                      <p>
                        Discover exquisite dining experiences at our renowned restaurants & bars.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={pool} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={pool} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Swimming Pool</a>
                      </h3>
                      <p>
                        Swimming pool shimmered invitingly under the scorching summer sun rays.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={games} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={games} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Games</a>
                      </h3>
                      <p>
                        Explore vast worlds, conquer foes, master skills: Gaming adventures await.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={bornfire} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={bornfire} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">BornFire</a>
                      </h3>
                      <p>
                        BornFire blazes, igniting passion in hearts, fueling dreams to soar.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={krokio} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={krokio} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Karaoke</a>
                      </h3>
                      <p>
                        Sing along with friends, unleash joy, music fills the night.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="services-08-item mb-30">
                    <div className="services-icon2">
                      <img src={ture} alt="img" />
                    </div>
                    <div className="services-08-thumb">
                      <img src={ture} alt="img" />
                    </div>
                    <div className="services-08-content">
                      <h3>
                        <a href="#">Tour Guide</a>
                      </h3>
                      <p>
                        Explore vibrant sights, taste local flavors, embrace culture. Your journey awaits.
                      </p>

                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
      <section id="services" className="services-area pt-113 pb-150">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-12">
              <div className="section-title center-align mb-50 text-center">
                <h5>The pleasure of luxury</h5>
                <h2>Rooms &amp; Suites</h2>
                <p>
                  Discover luxurious rooms and suites, each tailored for your comfort and style preferences. Indulge in unparalleled hospitality.
                </p>
              </div>
            </div>
          </div>
          <div className="row services-active slick-initialized slick-slider slick-dotted">
            <div className="slick-list draggable">
              <div className="slick-track">
                <div className="row">
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    // pagination={{
                    //   clickable: true,
                    // }}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                      },
                    }}
                    loop={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                  >

                    <SwiperSlide>
                      <div
                        className="slick-slide slick-cloned"
                        data-slick-index={-3}
                        id=""
                        aria-hidden="true"
                        tabIndex={-1}
                      // style={{ width: 440 }}
                      >
                        <div className="single-services mb-30">
                          <div className="services-thumb">
                            <a
                              className="gallery-link popup-image"
                              href={rroms}
                              tabIndex={-1}
                            >
                              <img src={rroms} alt="img" style={{ height: "312px" }} />
                            </a>
                          </div>
                          <div className="services-content">
                            <div className="day-book">
                              <ul style={{ textAlign: "center" }}>

                                <li>
                                  <a href="https://asiatech.in/book_now/account/3735623638343034643062623462326531336662376630333937323663353165" tabIndex={-1}>
                                    Book Now
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <h4>
                              <a href="single-rooms.html" tabIndex={-1}>
                                Deluxe Room
                              </a>
                            </h4>
                            <p>
                              Indulge in luxury with our exquisite deluxe room, perfect for ultimate relaxation.
                            </p>
                            <div className="icon">
                              <ul>
                                <li>
                                  <img src={I1} alt="img" />
                                </li>
                                <li>
                                  <img src={I2} alt="img" />
                                </li>
                                <li>
                                  <img src={I3} alt="img" />
                                </li>
                                <li>
                                  <img src={I4} alt="img" />
                                </li>
                                <li>
                                  <img src={I5} alt="img" />
                                </li>
                                <li>
                                  <img src={I6} alt="img" />
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div
                        className="slick-slide slick-cloned"
                        data-slick-index={-3}
                        id=""
                        aria-hidden="true"
                        tabIndex={-1}
                      // style={{ width: 440 }}
                      >
                        <div className="single-services mb-30">
                          <div className="services-thumb">
                            <a
                              className="gallery-link popup-image"
                              href={coze}
                              tabIndex={-1}

                            >
                              <img src={coze} alt="img" style={{ height: "312px" }} />
                            </a>
                          </div>
                          <div className="services-content">
                            <div className="day-book">
                              <ul style={{ textAlign: "center" }}>

                                <li>
                                  <a href="https://asiatech.in/book_now/account/3735623638343034643062623462326531336662376630333937323663353165" tabIndex={-1}>
                                    Book Now
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <h4>
                              <a href="single-rooms.html" tabIndex={-1}>
                                Cozy Villa
                              </a>
                            </h4>
                            <p>
                              Tranquil retreat nestled amidst nature's embrace, offering serenity and comfort.
                            </p>
                            <div className="icon">
                              <ul>
                                <li>
                                  <img src={I1} alt="img" />
                                </li>
                                <li>
                                  <img src={I2} alt="img" />
                                </li>
                                <li>
                                  <img src={I3} alt="img" />
                                </li>
                                <li>
                                  <img src={I4} alt="img" />
                                </li>
                                <li>
                                  <img src={I5} alt="img" />
                                </li>
                                <li>
                                  <img src={I6} alt="img" />
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div
                        className="slick-slide slick-cloned"
                        data-slick-index={-3}
                        id=""
                        aria-hidden="true"
                        tabIndex={-1}
                      // style={{ width: 440 }}
                      >
                        <div className="single-services mb-30">
                          <div className="services-thumb">
                            <a
                              className="gallery-link popup-image"
                              href="https://www.siaresort.com/img/accomodation/grand-6.jpg"
                              tabIndex={-1}
                            >
                              <img src="https://www.siaresort.com/img/accomodation/grand-6.jpg" alt="img" style={{ height: "312px" }} />
                            </a>
                          </div>
                          <div className="services-content">
                            <div className="day-book">
                              <ul style={{ textAlign: "center" }}>

                                <li>
                                  <a href="https://asiatech.in/book_now/account/3735623638343034643062623462326531336662376630333937323663353165" tabIndex={-1}>
                                    Book Now
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <h4>
                              <a href="single-rooms.html" tabIndex={-1}>
                                Grand Villa
                              </a>
                            </h4>
                            <p>
                              Luxurious retreat, where opulence meets comfort in serene surroundings.
                            </p>
                            <div className="icon">
                              <ul>
                                <li>
                                  <img src={I1} alt="img" />
                                </li>
                                <li>
                                  <img src={I2} alt="img" />
                                </li>
                                <li>
                                  <img src={I3} alt="img" />
                                </li>
                                <li>
                                  <img src={I4} alt="img" />
                                </li>
                                <li>
                                  <img src={I5} alt="img" />
                                </li>
                                <li>
                                  <img src={I6} alt="img" />
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="feature-area2 p-relative fix"
        style={{
          background: `linear-gradient(to right, rgba(132, 34, 107, 0.5), rgba(132, 34, 107, 0.5)), url(${home3})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundAttachment: "fixed"
        }}

      >
        <div className="animations-02">
          {/* <img src="img/bg/an-img-02.png" alt="contact-bg-an-05" /> */}
        </div>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12 pr-30">
              <div className="feature-img">
                <img
                  src={home3}
                  alt="img"
                  className="img"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12" >
              <div className="feature-content s-about-content">
                <div className="feature-title pb-20">
                  <h5 style={{ color: "white" }}>Luxury Resort</h5>
                  <h2 style={{ color: "white" }}>Experience Sia Resort's allure.</h2>
                </div>
                <p style={{ color: "white" }}>
                  Experience the captivating charm of Sia Resort, where every moment beckons you into a realm of serenity. Set amidst breathtaking landscapes, our sanctuary of luxury and tranquility eagerly anticipates your presence. From exhilarating outdoor escapades to immersive cultural encounters, embark on a journey filled with unparalleled delights.
                </p>
                <p style={{ color: "white" }}>
                  Our dedicated staff ensures personalized service, catering to your every need with warmth and professionalism. Whether you seek relaxation or excitement, Sia Resort offers the perfect escape. Unwind in elegant accommodations, dine on exquisite cuisine, and explore the beauty of our surroundings. Discover the essence of serenity and rejuvenation at Sia Resort – your ultimate getaway destination.
                </p>
                <div className="slider-btn mt-15">
                  <a href="/ROOMS" className="btn ss-btn smoth-scroll" style={{ border: "0.5px solid white" }}>
                    Discover More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="testimonial-area pt-120 pb-90 p-relative fix"
        style={{
          backgroundImage: "url(https://htmldemo.zcubethemes.com/riorelax/img/bg/testimonial-bg.png)",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title center-align mb-50 text-center">
                <h5>Testimonial</h5>
                <h2>What Our Clients Says</h2>
                <p>
                  Absolutely thrilled with the service! Prompt responses, professional team, and exceptional results. Couldn't be happier. Highly recommend!
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="testimonial-active slick-initialized slick-slider slick-dotted">
                <div className="slick-list draggable">
                  <div className="slick-track" style={{}}>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={10}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 3,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 3,
                          spaceBetween: 50,
                        },
                      }}
                      loop={true}
                      modules={[Autoplay, Pagination, Navigation]}

                      className="mySwiper"
                    >
                      <SwiperSlide>
                        {" "}
                        <div
                          className="single-testimonial slick-slide slick-cloned"
                          data-slick-index={-3}
                          id=""
                          aria-hidden="true"
                          tabIndex={-1}

                        >
                          <div className="testi-author">
                            <img
                              src="data:image/jpeg;base64,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"
                              alt="img"
                            />
                            <div className="ta-info">
                              <h6>dragon master</h6>
                              <span>Client</span>
                            </div>
                          </div>
                          <div className="review-icon">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/review-icon.png"
                              alt="img"
                            />
                          </div>
                          <p>
                            “Had a very good experience. Fun place to stay. Good food good taste. Have a very good environment.”
                          </p>
                          <div className="qt-img">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/qt-icon.png"
                              alt="img"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        {" "}
                        <div
                          className="single-testimonial slick-slide slick-cloned"
                          data-slick-index={-3}
                          id=""
                          aria-hidden="true"
                          tabIndex={-1}

                        >
                          <div className="testi-author">
                            <img
                              src="https://www.tamasbedo.com/en/wp-content/uploads/2020/02/women-1.jpg"
                              alt="img"
                            />
                            <div className="ta-info">
                              <h6>Nikita Advani</h6>
                              <span>Client</span>
                            </div>
                          </div>
                          <div className="review-icon">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/review-icon.png"
                              alt="img"
                            />
                          </div>
                          <p>
                            “The food was amazing staff was helpful thankyou for the overall things we had come to enjoy our Titan picnic thanks sia resort for making it easy”.
                          </p>
                          <div className="qt-img">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/qt-icon.png"
                              alt="img"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        {" "}
                        <div
                          className="single-testimonial slick-slide slick-cloned"
                          data-slick-index={-3}
                          id=""
                          aria-hidden="true"
                          tabIndex={-1}

                        >
                          <div className="testi-author">
                            <img
                              src="data:image/jpeg;base64,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"
                              alt="img"
                            />
                            <div className="ta-info">
                              <h6>Chitra Poojari</h6>
                              <span>Client</span>
                            </div>
                          </div>
                          <div className="review-icon">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/review-icon.png"
                              alt="img"
                            />
                          </div>
                          <p>
                            “This is located near the beach, the rooms are spacious and clean. The food here is absolutely delicious. I loved my stay here and definitely recommend it.”
                          </p>
                          <div className="qt-img">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/qt-icon.png"
                              alt="img"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        {" "}
                        <div
                          className="single-testimonial slick-slide slick-cloned"
                          data-slick-index={-3}
                          id=""
                          aria-hidden="true"
                          tabIndex={-1}

                        >
                          <div className="testi-author">
                            <img
                              src="https://www.findtherightclick.com/wp-content/uploads/2017/07/Matt-T-Testimonial-pic.jpg"
                              alt="img"
                            />
                            <div className="ta-info">
                              <h6>Laukik Bhoir</h6>
                              <span>Client</span>
                            </div>
                          </div>
                          <div className="review-icon">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/review-icon.png"
                              alt="img"
                            />
                          </div>
                          <p>
                            “Had a one day stay here.. very polite staff. the rooms were clean and also with a mesmerising view. definitely worth a stay”.
                          </p>
                          <div className="qt-img">
                            <img
                              src="https://htmldemo.zcubethemes.com/riorelax/img/testimonial/qt-icon.png"
                              alt="img"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="testimonial-area pt-120 pb-90 p-relative fix repetefood"
        style={{
          // backgroundImage: `url(${backgroundfood})`,
          background: ` linear-gradient(to right, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${backgroundfood})`,


        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title center-align mb-50 text-center">
                <h5>Foods</h5>
                <h2>Foods</h2>
                <p style={{ color: "black" }}>
                  Savor the rich flavors, indulge in culinary delights, and experience pure gastronomic bliss with every bite. Bon appétit!
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="testimonial-active slick-initialized slick-slider slick-dotted">
                <div className="slick-list draggable">
                  <div className="slick-track" style={{}}>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={10}
                      // pagination={{
                      //   clickable: true,
                      // }}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 4,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 4,
                          spaceBetween: 50,
                        },
                      }}
                      loop={true}
                      modules={[Autoplay, Pagination, Navigation]}
                      className="mySwiper"
                    >

                      <SwiperSlide>
                        {" "}
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two margin-top">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={buttergarlic}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-2.html">Butter garlic crab <BiFoodTag style={{ color: "red" }} /></a>
                              </h4>
                              <div className="text desc textpera" style={{ color: "black" }}>

                                Delicious butter garlic crab a savory delight for seafood enthusiasts.
                              </div>

                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={crabsmasala}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-3.html">Crab masala  <BiFoodTag style={{ color: "red" }} /></a>
                              </h4>
                              <div className="text desc textpera" style={{ color: "black" }}>
                                Delicious crab masala bursting with flavors, a culinary delight awaits.
                              </div>
                              {/* <div className="price">$15.00</div> */}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        {" "}
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two margin-top">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={clabsplatter}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-2.html">Crab platter <BiFoodTag style={{ color: "red" }} /></a>
                              </h4>
                              <div className="text desc textpera" style={{ color: "black" }}>
                                Indulge in our sumptuous crab platter, a seafood lover's delight!
                              </div>

                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={pomfretgrilled}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-3.html">Pomfret grilled  <BiFoodTag style={{ color: "red" }} /></a>
                              </h4>
                              <div className="text desc textpera" style={{ color: "black" }}>
                                Juicy Pomfret grilled to perfection, bursting with flavor and succulence.
                              </div>
                              {/* <div className="price">$15.00</div> */}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        {" "}
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two margin-top">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={porfedtandoor}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-2.html">Pomfret tandoori <BiFoodTag style={{ color: "red" }} /></a>
                              </h4>
                              <div className="text desc textpera" style={{ color: "black" }}>
                                Flavorful Pomfret Tandoori: Grilled perfection with a tantalizing spice blend.
                              </div>

                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={greensalad}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-3.html">Green Salad <BiFoodTag style={{ color: "green" }} /></a>
                              </h4>
                              <div className="text desc textpera" style={{ color: "black" }}>
                                Fresh greens, crunchy veggies, tossed with zesty vinaigrette. Healthy indulgence.
                              </div>
                              {/* <div className="price">$15.00</div> */}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div
                          className="owl-item cloned"
                          style={{ width: "100%", marginRight: 45 }}
                        >
                          <div className="offer-block-two">
                            <div className="inner-box">
                              <div className="image">
                                <a href="#">
                                  <img
                                    src={tandoorrawas}
                                    className="imagefood"
                                    alt=""
                                  />
                                </a>
                              </div>
                              <h4 className="foodtext">
                                <a href="menu-list-3.html">Tandoori rawas  <BiFoodTag style={{ color: "red" }} /></a>
                              </h4>
                              <div className="text desc textpera textpera" style={{ color: "black" }}>
                                Succulent Tandoori Rawas: A Flavourful Delight for Seafood Connoisseurs!
                              </div>
                              {/* <div className="price">$15.00</div> */}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>

                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="booking pt-120 pb-120 p-relative fix">
        <div className="animations-01"></div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 order-md-1 order-2" >
              <div className="contact-bg02">
                <div className="section-title center-align">
                  <h5>make appointment</h5>
                  <h2>Book A Room</h2>
                </div>
                <form
                  action="mail.php"
                  method="post"
                  className="contact-form mt-30"
                  ref={formRef}  {...props}
                >
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="contact-field p-relative c-name mb-20">
                        <label>
                          <i className="fal fa-badge-check" /> Name
                        </label>
                        <input
                          type="text"
                          id="firstn"
                          name="firstn"
                          placeholder="First Name"
                          required=""
                          onChange={(e) => setCustName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="contact-field p-relative c-subject mb-20">
                        <label>
                          <i className="fal fa-times-octagon" /> Email
                        </label>
                        <input
                          type="text"
                          id="email"
                          name="email"
                          placeholder="Eamil"
                          required=""
                          onChange={(e) => setCustEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="contact-field p-relative c-subject mb-20">
                        <label>
                          <i className="fal fa-users" /> Phone Number
                        </label>
                        <input
                          type="text"
                          id="phone"
                          name="phone"
                          placeholder="Phone No."
                          required=""
                          onChange={(e) => setCustContact(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="contact-field p-relative c-option mb-20">
                        <label>
                          <i className="fal fa-concierge-bell" /> Subject
                        </label>
                        <input
                          type="text"
                          id="subject"
                          name="subject"
                          placeholder="Subject"
                          onChange={(e) => setCustSubject(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="contact-field p-relative c-option mb-20">
                        <label>
                          <i className="fal fa-concierge-bell" /> Message
                        </label>
                        <textarea
                          name="message"
                          id="message"
                          cols={30}
                          rows={10}
                          placeholder="Write comments"
                          defaultValue={""}
                          onChange={(e) => setCustMessage(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="slider-btn mt-15">
                        <button
                          className="btn ss-btn"
                          data-animation="fadeInRight"
                          data-delay=".8s"
                          onClick={Appoinment}
                        >
                          <span>Enquire Now</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 order-md-2 order-1">
              <div className="booking-img">
                <img src={siamain} alt="img" style={{ height: "572px" }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
